export { default } from "./product-tag";
